PegasusTemplate.FragmentBaseMixin = Ember.Mixin.create({
  html: DS.attr('string'),
  type: DS.attr('string'),
  dataRemovable: DS.attr('string', { defaultValue: "false" }),
  placeholderHTML: DS.attr('string'),
  isRemovable: function(){
    return this.get('dataRemovable') === "true";
  }.property('dataRemovable')
});

PegasusTemplate.Model = DS.Model.extend(PegasusTemplate.FragmentBaseMixin, {
  isClean: function(){
    return ( !this.get('isSaving') && !this.get('isDirty') );
  }.property('isSaving', 'isDirty'),

  observeSaveOnce: function(options) {
    function callback() {
      var outcome = 'success';
      if (this.get('isDirty')) {
        if (this.get('isValid')) { return; } // not submitted yet
        outcome = 'error';
      }

      (options[outcome] || Ember.K).call(this);

      this.removeObserver('isDirty', callback);
      this.removeObserver('isValid', callback);
    }

    if( this.get('isDirty') || !this.get('isValid') ){
      this.addObserver('isDirty', callback);
      this.addObserver('isValid', callback);
    }
  }
});

PegasusTemplate.Model.FIXTURES = [];
